'use client';

import { Textarea  } from '@chakra-ui/react';
import type { TextareaProps } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

import type { FormBaseInputProps } from '../../../types';
import { FormFloatingFieldText } from '../../wrapper/FormFloatingFieldText/FormFloatingFieldText';

type CounterProps = {
	maxChars?: number
};

export type TextAreaInputProps<T> = FormBaseInputProps<T> & Omit<TextareaProps, 'name'> & CounterProps;

export const TextAreaInput = <T extends Record<string, unknown>>({
	helperText,
	label,
	maxChars,
	name,
	optionalText,
	required,
	...textAreaInputProps
}: TextAreaInputProps<T>) => {
	const { register } = useFormContext<T>();

	return (
		<FormFloatingFieldText
			helperText={helperText}
			label={label}
			maxChars={maxChars}
			name={name}
			optionalText={optionalText}
			required={required}
		>
			<Textarea
				{...register(name)}
				maxLength={typeof maxChars === 'number' ? maxChars : undefined}
				{...textAreaInputProps}
			/>
		</FormFloatingFieldText>
	);
};
